// Module
var code = "<h2 id=\"have-questions-about-terms-on-your-bill\">Have questions about terms on your bill?</h2> <p>Check out our glossary for help.</p> ";
// Exports
export default code;